// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"98d30458","219":"635bfbe6","240":"2b17981a","267":"8eba6cef","712":"854fdaaf","787":"ecfc6e73","816":"18a90924","891":"04139625"}[chunkId] + ".chunk.js";
};